<template>
  <div class="corp-profit">
    <template-form
      :isBack="true"
      title="ทีนี้มาลองคำนวณความต่างของกำไร"
      description="เปรียบเทียบการซื้อของมี VAT/ ไม่มี VAT"
    >
      <div class="cpb-answer">
        {{ labelIncome }}
        <currency v-model="onlineSelling" v-on:change="setOnlineSelling" />
      </div>
      <div class="cpb-answer">
        {{ labelCost }}
        <currency v-model="cost" v-on:change="setCost" />
      </div>

      <material-button
        class="cpb-button"
        :disabled="!validate"
        @clickButton="$router.push('/forms/goods_vat_summary')"
      >
        ถัดไป
      </material-button>
    </template-form>

    <StateAnswer />
    <modal v-if="isOpenModal">
      <div slot="body">
        <img
          :src="VECTOR"
          class="img-vector"
          style="margin-top: 20px; margin-bottom: 30px;"
        />
        <div class="red-modal" style="margin-bottom: 10px;">
          เดี๋ยวก่อน !! <br />ซื้อของไม่มี Vat ไม่มีเอกสารที่ถูกต้อง
          <br />เอามาใช้เป็นต้นทุนของเราไม่ได้นะ!!
        </div>
      </div>
      <div slot="footer" class="footer-modal">
        <material-button
          class="ptcb-button button-secondary btn-size"
          @clickButton="closeModal"
        >
          ปิด
        </material-button>
      </div>
    </modal>
  </div>
</template>

<script>
import StateAnswer from "@/components/StateAnswer.vue";
import VECTOR from "@/assets/images/vector-alert.png";

export default {
  name: "CorpProfit",
  components: {
    StateAnswer,
  },
  data() {
    const onlineSelling = this.$store.getters["taxInfo/getIncome"]
      .onlineSelling;
    const cost = this.$store.getters["taxInfo/getExpense"].cost;
    const goodsType = this.$store.getters["questions/getAnswers"].goodsType;
    const labelIncome = "รายได้จากการขายสินค้าต่อเดือน (รวม VAT)";
    const labelCost = goodsType
      ? "ต้นทุนสินค้าต่อเดือน (รวม VAT)"
      : "ต้นทุนสินค้าต่อเดือน (ไม่รวม VAT)";

    return {
      onlineSelling,
      cost,
      labelIncome: labelIncome,
      labelCost: labelCost,
      VECTOR,
      isOpenModal: !goodsType,
    };
  },
  methods: {
    closeModal() {
      this.isOpenModal = false;
    },
    setOnlineSelling(value) {
      this.$store.dispatch("taxInfo/addIncomeValue", {
        name: "onlineSelling",
        value: value,
      });
    },
    setCost(value) {
      this.$store.dispatch("taxInfo/addExpenseValue", {
        name: "cost",
        value: value,
      });
    },
  },
  computed: {
    validate: function () {
      const onlineSelling = this.$store.state.taxInfo.income.onlineSelling;
      const cost = this.$store.state.taxInfo.expense.cost;

      let valid = false;
      if (onlineSelling > 0) {
        if (cost > 0) {
          valid = true;
        }
      }
      return valid;
    },
  },
};
</script>

<style scoped>
.corp-profit {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  justify-content: space-between;
}
.red-modal {
  color: #f45a49;
  font-weight: bold;
  font-size: 19px;
}
.cpb-answer {
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
  width: 100%;
  max-width: 352px;
  box-sizing: border-box;
}
.cpb-button {
  max-width: 352px;
  margin-top: 16px;
  margin-bottom: 14px;
}
</style>
